'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

ElementService=class ElementService extends BaseService{
constructor(){
super();
}

selectElement(selector){
if(selector instanceof Object&&Object.getPrototypeOf(selector)===this._ngElementPrototype){
return selector;
}

return angular.element(selector);
}

setText(selector,text){
return this.selectElement(selector).text(text);
}

removeClass(selector,classToRemove){
return this.selectElement(selector).removeClass(classToRemove);
}

removeAttr(selector,attrToRemove){
return this.selectElement(selector).removeAttr(attrToRemove);
}

addClass(selector,classToAdd){
return this.selectElement(selector).addClass(classToAdd);
}

hasClass(selector,classToCheck){
return this.selectElement(selector).hasClass(classToCheck);
}

hasAnyClass(selector,classesToCheck){
const classList=this.classList(selector);
if(classList.length===0){
return!1;
}

const classListSet=new Set(classList);
return _.some(classesToCheck,cl=>classListSet.has(cl));
}

classList(selector){
return _.toArray(this.selectElement(selector).prop('classList'));
}

setAttributeIfNew(selector,attr,value){
const el=this.selectElement(selector);
if(el.attr(attr)===value){
return;
}

return el.attr(attr,value);
}

get _ngElementPrototype(){
return this.__ngElementPrototype||(this.__ngElementPrototype=Object.getPrototypeOf(angular.element(document.createDocumentFragment('div'))));
}};


module.exports=ElementService;
//# sourceMappingURL=elementService.js.map
